/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 支付下单
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  paymentOrderDTO: payment.PaymentOrderDTO,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: payment.BestPayResponseBO;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/payment/best-pay/order`,
    data: paymentOrderDTO,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
